<template>
  <j-modal
    title="接口调用测试"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <emp-aicsp-log-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></emp-aicsp-log-form>
  </j-modal>
</template>

<script>

  import EmpAicspLogForm from './EmpAicspLogForm'
  export default {
    name: 'EmpAicspLogModal',
    components: {
      EmpAicspLogForm
    },
    data () {
      return {
        title:'',
        width:1500,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        //this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>